export const getConsentCategoryIds = () =>
  window.OnetrustActiveGroups || "C0001";
